<template>
  <div class="yunxiao parent member-modify">
    <div class="contain">
      <van-field
        v-model="studentInfos.name"
        required
        ref="studentNameInput"
        maxlength="20"
        input-align="right"
        label="姓名"
        :formatter="(v) => v.trimLeft()"
        placeholder="请填写学生姓名"
      />
      <div class="info-wrapper" style="margin-top: calc(var(--gap) * 18)">
        <div class="info-item">
          <div class="item-label required">性别</div>
          <div class="item-right">
            <van-radio-group
              v-model.number="studentInfos.sex"
              direction="horizontal"
            >
              <van-radio :name="1">男</van-radio>
              <van-radio :name="0">女</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="info-item">
          <div class="item-label">出生日期</div>
          <div
            class="item-right"
            @click="chooseDate"
            :class="{ placeholder: !studentInfos.birthday }"
          >
            <span class="item-value">
              {{ studentInfos.birthday || "请选择" }}
            </span>
            <span class="item-icon"><van-icon name="arrow" size="var(--fs-lg)" /></span>
          </div>
        </div> 

        
        <custom-fields class="custom-fields-nav" :fields="formatFields(customFieldList)" ref="customFields" />     
      </div>

      <div class="line-title required" style="margin-top: calc(var(--gap) * 18)">
        联系方式<br />
        <span class="tips">
          用下面填写的号码注册学员端账号可查看学员上课信息，请正确填写手机号码
        </span>
      </div>
      <div class="info-wrapper">
        <div class="right-column-tips">
          设为常用联系人
        </div>
        <van-field
          class="parent-field"
          v-for="(item, idx) of studentInfos.studentParentRelation"
          :key="idx"
        >
          <template #label>
            <div
              class="relation-nav"
              :class="{ placeholder: !item.relation }"
              @click="pickerRelation(idx)"
            >
              <i class="required-relation" v-if="item.often"></i>
              <van-icon
                v-if="studentInfos.studentParentRelation.length > 1 && !item.often"
                class="delete-relation"
                class-prefix="vxs-icon"
                name="system_del"
                size="16"
                color="var(--c3)"
                @click.stop="studentInfos.studentParentRelation.splice(idx, 1)"
              />
              {{ item.relation || "请选择" }}
              <van-icon name="arrow-down" size="var(--fs-lg)"/>
            </div>
          </template>
          <template #input>
            <van-field
              class="input-solt-field"
              v-model="item.parentPhone"
              clearable
              name="phone"
              type="tel"
              maxlength="11"
              input-align="left"
              :border="false"
              :formatter="(v)=>v.replace(/[^0-9]/g, '')"
              placeholder="请输入手机号码"
            />
            <div class="right-radio-column" :class="{active: item.often}" @click="changeOften(item)">
              <div class="circle"></div>
            </div>
          </template>
        </van-field>
        <div
          class="info-item add-btns"
          @click="
            studentInfos.studentParentRelation.push({ relation: '妈妈', parentPhone: '' })
          "
        >
          <i class="vxs-icon vxs-icon-system_add"></i>新增联系方式
        </div>
      </div>
    </div>
    <page-footer-btn multipleBtns>
      <van-button 
        square round 
        block  
        @click="$router.back()"
        data-test="base-student-input-btn-save">
        取消
      </van-button>
      <van-button 
        square round 
        block 
        type="primary" 
        @click="inputSubmit()" 
        data-test="base-student-input-btn-register">
        保存
      </van-button>
    </page-footer-btn>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";
import customField from "./mixins/customField.js";
import customFields from "./coms/custom-fields.vue";

export default {
  name: 'memberModify',
  mixins: [ customField({combineCustomFieldProps: 'studentInfos', businessType: 'STUDENT_OFFICIALLY'}) ],
  components: {
    customFields,
    pageFooterBtn
  },
  data () {
    return {
      pageTitle: '完善学员信息',
      studentInfos: {
        name: "",
        sex: 1,
        birthday: "",
        gradeName: "",
        studentParentRelation: [
          {
            relation: "妈妈",
            parentPhone: "",
          },
        ],
      },
    }
  },
  computed:{
    memberUseInfo () {
      return this.$store.state.memberUserInfos || {};
    },
  },
  methods: {
    formatFields(list){
      list && list.forEach(item=> {
        if (item.fieldDataType == 5 && !item.valueList) {
          this.$set(item, 'valueList', []);
        }
      })
      return list;
    },
    // 选择出生日期
    chooseDate(v) {
      app.x3.picker
        .datetime({
          type: "date",
          "min-date": new Date("1900-01-01"),
          value: new Date(
            this.studentInfos.birthday.replace(/\-/g, '/') || "2010/01/01"
          ),
        })
        .then((res) => {
          this.studentInfos.birthday = app.tool.date.filterDate(res);
        });
    },
    // 选择关系
    pickerRelation(idx) {
      let parentInfos = this.studentInfos.studentParentRelation[idx];
      app.x3.picker
        .relation(parentInfos.relation, {
          title: "请选择关系",
        })
        .then((res) => {
          this.$set(this.studentInfos.studentParentRelation[idx], "relation", res);
        });
    },
    // 回显学生数据
    showStudentInfos(data) {
      data.birthday = data.birthday ? data.birthday.replace(/T.*/, '') : '';
      Object.assign(this.studentInfos, data);
    },
    // 获取学生信息并回显
    async getStudentInfos(bool) {
      let id = this.memberUseInfo.studentId;
      !bool && this.showLoading();
      if (id !== undefined) {
        try {
          // let res = await this.$api.studentGet({id});
          let res = await this.$api.memberGetContainFace({
            studentId: id,
          });
          if (res.code === 200) {
            this.showStudentInfos(res.data);
            this.doCombineCustomFieldProps();
          }
        } catch (err) {
          console.error('获取学员详细信息出错', err);
        }
      }
      !bool && this.$toast.clear();
    },
    inputSubmit () {
      let { name, studentParentRelation } = this.studentInfos;
      if (name.trim().length == 0) {
        this.$toast("请输入学员姓名。");
        this.$refs.studentNameInput && this.$refs.studentNameInput.focus();
        return false;
      }

      if (this.$refs['customFields']) {
        if (!this.$refs['customFields'].validate()) {
          return false;
        }
      }
      // 找出填写未完整的手机号码的关系
      let validatedTels = studentParentRelation.filter((v) => {
        return !/^\d{11}$/.test(v.parentPhone)
      });
      // 存在填写未正确的手机号码
      if (validatedTels.length) {
        this.$toast("联系方式有误，请核对填写内容");
        return false;
      }

      // 校验是否存在重复的手机号码
      let telObj = {};
      for (let {parentPhone} of studentParentRelation) {
        if (telObj[parentPhone]) {
          this.$toast("联系方式重复，请核对填写内容");
          return false;
        }
        telObj[parentPhone] = true;
      }
      this.showLoading();
      this.$api
        .updateMemberInfo(
          Object.assign(this.studentInfos, {
            studentParentRelation: studentParentRelation,
            name: name.trim(),
            customFieldList: this.customFieldList,
            memberId: this.memberUseInfo.id,
          })
        )
        .then((res) => {
          if (res.code === 200) {
            this.$toast.success("更新学员信息成功");
            app.vue.$emit('updateInfosSuccess')
            this.$router.back();
          }
        })
        .catch((err) => {
          console.log(err);
        });

    },
    changeOften(item) {
      if (item.often) return false;
      let relationTels = this.studentInfos.studentParentRelation;
      relationTels.forEach(v=>this.$set(v, 'often', false));
      this.$set(item, 'often', true);
    }
  },
  created () {
    if (this.memberUseInfo.studentId) {
      this.getStudentInfos();
    } else {
        this.$toast('请选择学员');
        this.$router.push('/member-stu-chooser');
    }
  },
}
</script>

<style lang="scss">
.yunxiao.parent.member-modify {
  display: flex;
  flex-direction: column;
  height: 100%;
  .contain {
    flex: 1;
    color: var(--g8);
    overflow-y: auto;
    .info-wrapper {
      font-size: var(--fs-md);
      background-color: var(--white);
      padding: 0 calc(var(--gap) * 16);
      .info-item {
        padding: calc(var(--gap) * 12) 0;
        min-height: calc(var(--w) * 54);
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:not(:last-child) {
          border-bottom: 0.5px solid var(--g3);
        }
        .item-add-btn {
          color: var(--c1);
          font-size: var(--fs-lg);
          > .van-icon {
            margin-right: calc(var(--gap) * 4);
            vertical-align: text-top;
          }
        }
        .item-right {
          text-align: right;
          display: flex;
          align-items: center;
          &.placeholder {
            color: var(--g5);
          }
          .item-icon {
            height: calc(var(--w) * 16);
            margin-left: calc(var(--gap) * 8);
            color: var(--g6);
          }
        }
      }
      .info-item.add-btns {
        justify-content: flex-start;
        align-items: center;
        color: var(--c1);
        .vxs-icon-system_add {
          margin-right: calc(var(--gap) * 4);
        }
      }
      .van-cell {
        padding: calc(var(--gap) * 12) 0;
        &::after {
          right: 0px;
          left: 0px;
        }
        .van-cell__title {
          color: var(--g8);
        }
        .van-field__body {
          padding-right: calc(var(--gap) * 6);
          .van-field__control {
            text-align: right;
          }
        }
        .input-solt-field {
          padding: 0;
          .van-field__body {
            padding-right: 0;
            .van-field__control {
              text-align: left;
            }
          }
        }
        .parent-field {
          display: flex;
          .van-cell__title {
            width: auto;
            margin-right: calc(var(--gap) * 12);
          }
          .van-cell__value {
            flex: 1;
          }
        }
        .relation-nav {
          display: flex;
          align-items: center;
          .required-relation{
            display: flex;
            width: calc(var(--w) * 16);
            margin-right: calc(var(--gap) * 8);
            color: var(--c3);
            align-items: center;
            justify-content: center;
            font-size:var(--fs-lg);
            &::before{
              display: block;
              content:"*";
              height: calc(var(--w) * 16);
            }
          }
          .delete-relation {
            margin-right: calc(var(--gap) * 8);
          }
          .van-icon-arrow-down {
            color: var(--g4);
            margin-left:calc(var(--gap) * 4);
          }
          &.placeholder {
            color: var(--g5);
          }
        }
      }
      .info-item .item-label.required {
        &::before {
          margin-left: calc(var(--gap) * -5);
          margin-right: calc(var(--gap) * 1);
          color: var(--c3);
          font-size: var(--fs-lg);
          content: "*";
        }
      }
      > .van-cell--required::before,
      .info-item > .van-cell--required::before {
        display: none;
      }
      .info-item > .van-cell {
        padding: 0;
      }
      .repetitive-tips {
        box-sizing: border-box;
        padding-right: calc(var(--gap) * 6);
        margin: 0 0 calc(var(--gap) * 10) 0;
        width: 100%;
        text-align: right;
        color: var(--g6);
        > span {
          color: var(--c1);
        }
      }
      .right-column-tips{
        text-align: right;
        color: var(--g6);
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        padding-top: calc(var(--gap) * 12);
      }
      .right-radio-column{
        display: flex;
        width: 7em;
        align-items: center;
        justify-content: center;
        color: var(--g6);
        .circle{
          width: calc(var(--w) * 14);
          height: calc(var(--w) * 14);
          border-radius: 50%;
          border: 1px solid var(--g6);
        }
        &.active{
          color: var(--c1);
          .circle{
            display: flex;
            margin: calc(var(--w) * -1) 0 0 calc(var(--w) * 1);
            border-color: var(--c1);
            align-items: center;
            justify-content: center;
            &::before{
              content:'';
              display: block;              
              width: calc(var(--w) * 6);
              height: calc(var(--w) * 6);
              border-radius: 50%;
              background-color: var(--c1);
            }
          }
        }
      }
    }
    .line-title {
      padding: 0 calc(var(--gap) * 16);
      min-height: calc(var(--w) * 40);
      color: var(--g8);
      font-size: var(--fs-md);
      line-height: calc(var(--w) * 40);
      &.required {
        &::before {
          margin-left: calc(var(--gap) * -5);
          color: var(--c3);
          font-size: var(--fs-lg);
          content: "*";
        }
      }
      .tips {
        display: inline-block;
        color: var(--g6);
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
      }
    }
  }
}
</style>